import {ViewType} from "../../../../gd/const/views/view-type"

export default function projectCollectionView_isPro(type: ViewType) {
    const company = gd.session.companies.get(gd.companyId)
    switch (type) {
        case ViewType.PORTFOLIO_GANTT       : return !company.license.portfolioView(ViewType.PROJECT_GANTT)
        case ViewType.PORTFOLIO_WORKLOAD    : return !company.license.portfolioView(ViewType.PROJECT_WORKLOAD)
    }

    return false
}